import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import axios, { AxiosError } from "axios";
import { projectUrls } from "../../../URL/ApplicationUrls";
import { MdmApiError } from "../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../Errors/apiErrorNotificationToast";

export const useCreateProjectFromSpdrs = () => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (spdrIds: number[]) => {
      return axios.post<number>(projectUrls.projectFromSpdrs, spdrIds);
    },
    onSuccess: async (result) => {
      navigate(projectUrls.projectWithId(result.data).uiPath);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
